<section class="account">

  <!-- The account: who is signed in. -->
  <div class="widget account__card">
    <div class="account__person">
      <span class="account__avatar"><%= account.initials %></span>
      <div class="account__who">
        <h2 class="account__name"><%= account.name %></h2>
        <span class="account__mail"><i class="icon icon--mail"></i> <%= account.email %></span>
      </div>
    </div>
    <dl class="account__facts">
      <div>
        <dt><%= _lcs( 'Rollen' ) %></dt>
        <dd class="role-badges">
          <% account.roles.forEach( function( r ) { %>
            <span class="role-badge role-badge--<%= r.key %>"><%= r.label %></span>
          <% } ); %>
        </dd>
      </div>
      <% if ( account.since ) { %>
        <div><dt><%= _lcs( 'Konto seit' ) %></dt><dd><%= account.since %></dd></div>
      <% } %>
    </dl>
    <div class="account__actions">
      <button type="button" class="btn btn--ghost btn--sm" data-action="settings">
        <i class="icon icon--key-round"></i> <%= _lcs( 'Passwort ändern' ) %>
      </button>
    </div>
  </div>

</section>
